<template>
  <!-- 多媒体集管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dbWork"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="mediaSetZyk"></LeftSideBar>
    </div>
    <div id="sortContent">
      <div class="left-tree">
        <el-input
          class="subject-search-input"
          placeholder="请输入名称"
          v-model="treeSearchContent"
        ></el-input>
        <el-tree
          ref="tree"
          v-if="opentree"
          :props="props"
          :load="loadNode"
          icon-class="el-icon-folder"
          highlight-current
          :expand-on-click-node="false"
          node-key="id"
          @node-click="listClick"
          :filter-node-method="treeSearch"
          lazy
        >
        </el-tree>
      </div>
      <div class="rightBox">
        <!-- 上方按钮 -->
        <div class="button-box">
          <!-- <el-button type="text" icon="el-icon-document-copy" size="small"
            >批量标引</el-button
          > -->

          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="firstCreate()"
            :disabled="this.listInnerCode == ''"
            >新增</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="preCheck('toDelete')"
            :disabled="this.listInnerCode == ''"
            >删除</el-button
          >
          <el-button
            type="text"
            icon="el-icon-refresh"
            size="small"
            @click="onRevert()"
            :disabled="this.deleteId.length == []"
            >恢复</el-button
          >
          <el-button
            type="text"
            icon="el-icon-c-scale-to-original"
            size="small"
            @click="createIndex()"
            :disabled="this.listInnerCode == ''"
            >创建索引</el-button
          >
          <!-- <el-button
            type="text"
            icon="el-icon-download"
            size="small"
            @click="SourceOut()"
            >资源出库</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-tickets"
            size="small"
            @click="listOut()"
            >按条目表出库</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-document-checked"
            size="small"
            @click="specialOut()"
            >专项内容出库</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-upload2"
            size="small"
            @click="reorderPre()"
            >导出列表</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-c-scale-to-original"
            size="small"
            @click="sourceCompare()"
            >资源对比</el-button
          > -->
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div id="searchBox">
            <el-form
              label-width="120px"
              ref="searchFileForm"
              :model="searchFileForm"
            >
              <el-form-item label="资源名称">
                <el-input
                  v-model="searchFileForm.title"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="全文检索">
                <el-input placeholder="请输入全文检索"></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="所属图书">
                <el-input placeholder="请输入所属图书"></el-input>
              </el-form-item> -->
              <el-form-item label="类型">
                <el-select
                  placeholder="请选择类型"
                  v-model="searchFileForm.type"
                  clearable
                >
                  <el-option value="1" label="图片"> </el-option>
                  <el-option value="2" label="视频"> </el-option>
                  <el-option value="3" label="音频"> </el-option>
                  <el-option value="4" label="3D"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="资源状态">
                <el-select v-model="searchFileForm.status" clearable>
                  <el-option value="10" label="下架"> </el-option>
                  <el-option value="20" label="上架"> </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="标引状态">
                <el-select placeholder="请选择来源">
                  <el-option> </el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="标引标签">
                <el-select placeholder="请选择来源">
                  <el-option> </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="
                    currentPage = 1;
                    onSearch();
                  "
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="tip-text" v-if="this.listInnerCode == ''">
              请选择资源库
            </div>
            <!-- 主列表 -->
            <div v-if="this.listInnerCode != ''">
              <el-table
                :data="bkTableData"
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="poster"
                  min-width="50"
                  align="center"
                  label="封面图"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.poster"
                      style="width: 100%; max-height: 90px"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  show-overflow-tooltip
                  label="类型"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.type == 1">图片</span>
                    <span effect="dark" v-if="scope.row.type == 2">视频</span>
                    <span effect="dark" v-if="scope.row.type == 3">音频</span>
                    <span effect="dark" v-if="scope.row.type == 4">3D</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isOriginal"
                  show-overflow-tooltip
                  label="是否存在原图"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isOriginal == 10"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isOriginal == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSize"
                  show-overflow-tooltip
                  label="文件大小"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="editSet(scope.row)"
                      >【编辑】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="preview(scope.row)"
                      >【预览】</span
                    >
                     <span
                      class="right-add-button"
                      style="display: block"
                      @click="publishPreview(scope.row)"
                      >【发布预览】</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize"
                >
                </el-pagination>
              </div>
            </div>
          </div>

          <el-dialog
            title="新增多媒体资源集"
            :visible.sync="createDialog"
            width="1000px"
          >
            <div class="createSetType">
              <span>请选择资源集类型：</span>
              <el-select
                placeholder="请选择类型"
                v-model="createSetType"
                @change="addTypeChange"
                clearable
              >
                <el-option value="1" label="图片"> </el-option>
                <el-option value="2" label="视频"> </el-option>
                <el-option value="3" label="音频"> </el-option>
              </el-select>
            </div>
            <el-form
              label-width="80px"
              ref="addSetForm"
              :model="addSetForm"
              :rules="addSetRules"
              style="padding: 10px 0"
            >
              <el-form-item label="资源名称" prop="title">
                <el-input
                  v-model="addSetForm.title"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="描述">
                <el-input
                  v-model="addSetForm.description"
                  placeholder="请输入描述"
                ></el-input> </el-form-item
              ><el-form-item label="分支" style="width: 50%" prop="subjectId">
                <!-- 分支树开始 -->
                <el-select
                  placeholder="请选择分支"
                  v-model="selectedValue"
                  style="width: 100%"
                  clearable
                >
                  <el-option :value="dataList"
                    ><el-tree
                      ref="subjectTree"
                      :props="props"
                      :load="loadNode"
                      check-on-click-node
                      highlight-current
                      :expand-on-click-node="false"
                      @check-change="handleCheckChange"
                      node-key="id"
                      lazy
                    >
                    </el-tree>
                  </el-option>
                </el-select>
                <!-- 分支树结束 -->
              </el-form-item>
            </el-form>
            <div id="creatTableBox">
              <!-- <div class="tableLoading">
                <i class="el-icon-loading"></i>
                <span>正在加载数据...</span>
              </div> -->
              <p
                style="
                  font-size: 16px;
                  margin: 0 10px;
                  padding: 20px 0;
                  position: relative;
                "
              >
                已选择资源:
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  style="position: absolute; top: 24%; right: 1%"
                  @click="toPoster()"
                  >添加为封面图</el-button
                >
                <!-- <span>添加为封面图</span> -->
              </p>
              <el-table
                :data="currentSetData"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange2"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isOriginal"
                  show-overflow-tooltip
                  label="是否存在原图"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isOriginal == 10"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isOriginal == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSize"
                  show-overflow-tooltip
                  label="文件大小"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      style="display: inline-block; margin-right: 10px"
                      @click="moveCreate(scope.row, scope.$index, 'up')"
                      >上移</span
                    >
                    <span
                      class="right-add-button"
                      style="display: inline-block; margin-right: 10px"
                      @click="moveCreate(scope.row, scope.$index, 'down')"
                      >下移</span
                    >
                    <span
                      class="right-add-button"
                      style="display: inline-block"
                      @click="deleteCreate(scope.row)"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div id="creatCheckTableBox">
              <!-- <div class="tableLoading">
                <i class="el-icon-loading"></i>
                <span>正在加载数据...</span>
              </div> -->
              <!-- 列表搜索 -->
              <div id="createSearchBox">
                <el-form
                  label-width="80px"
                  ref="searchCreateForm"
                  :model="searchCreateForm"
                >
                  <el-form-item label="资源名称">
                    <el-input
                      v-model="searchCreateForm.title"
                      placeholder="请输入资源名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label-width="0px">
                    <el-button
                      type="primary"
                      size="mini"
                      icon="el-icon-search"
                      @click="
                        currentPage = 1;
                        onCreateSearch();
                      "
                      >查询</el-button
                    >
                  </el-form-item>
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-folder"
                    class="setCreateSave"
                    @click="setCreateSave()"
                    >保存添加</el-button
                  >
                </el-form>
              </div>
              <el-table
                :data="creatSetData"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isOriginal"
                  show-overflow-tooltip
                  label="是否存在原图"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isOriginal == 10"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isOriginal == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSize"
                  show-overflow-tooltip
                  label="文件大小"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage1"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize1"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize1"
                >
                </el-pagination>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="onCreate('addSetForm')"
                >确 定</el-button
              >
              <el-button @click="createDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 编辑数据类别弹窗 -->
          <el-dialog
            title="编辑多媒体集"
            :visible.sync="editDialog"
            width="1000px"
          >
            <div class="createSetType">
              <span>请选择资源集类型：</span>
              <el-select
                placeholder="请选择类型"
                v-model="editSetType"
                @change="editTypeChange"
                clearable
              >
                <el-option value="1" label="图片"> </el-option>
                <el-option value="2" label="视频"> </el-option>
                <el-option value="3" label="音频"> </el-option>
              </el-select>
            </div>
            <el-form
              label-width="80px"
              ref="editSetForm"
              :model="editSetForm"
              :rules="editSetRules"
              style="padding: 10px 0"
            >
              <el-form-item label="资源名称" prop="title">
                <el-input
                  v-model="editSetForm.title"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="描述">
                <el-input
                  v-model="editSetForm.description"
                  placeholder="请输入描述"
                ></el-input> </el-form-item
              ><el-form-item label="分支" style="width: 50%" prop="subjectId">
                <!-- 分支树开始 -->
                <el-select
                  placeholder="请选择分支"
                  v-model="selectedValue"
                  style="width: 100%"
                  clearable
                >
                  <el-option :value="dataList"
                    ><el-tree
                      ref="subjectTree"
                      :props="props"
                      :load="loadNode"
                      check-on-click-node
                      highlight-current
                      :expand-on-click-node="false"
                      @check-change="handleCheckChange"
                      node-key="id"
                      lazy
                    >
                    </el-tree>
                  </el-option>
                </el-select>
                <!-- 分支树结束 -->
              </el-form-item>
            </el-form>
            <div id="creatTableBox">
              <!-- <div class="tableLoading">
                <i class="el-icon-loading"></i>
                <span>正在加载数据...</span>
              </div> -->
              <p
                style="
                  font-size: 16px;
                  margin: 0 10px;
                  padding: 20px 0;
                  position: relative;
                "
              >
                已选择资源:
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  style="position: absolute; top: 24%; right: 1%"
                  @click="toPoster2()"
                  >添加为封面图</el-button
                >
                <!-- <span>添加为封面图</span> -->
              </p>
              <el-table
                :data="editSetData"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange2"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isOriginal"
                  show-overflow-tooltip
                  label="是否存在原图"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isOriginal == 10"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isOriginal == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSize"
                  show-overflow-tooltip
                  label="文件大小"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      style="display: inline-block; margin-right: 10px"
                      @click="moveEdit(scope.row, scope.$index, 'up')"
                      >上移</span
                    >
                    <span
                      class="right-add-button"
                      style="display: inline-block; margin-right: 10px"
                      @click="moveEdit(scope.row, scope.$index, 'down')"
                      >下移</span
                    >
                    <span
                      class="right-add-button"
                      style="display: inline-block"
                      @click="deleteEdit(scope.row)"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div id="creatCheckTableBox">
              <!-- <div class="tableLoading">
                <i class="el-icon-loading"></i>
                <span>正在加载数据...</span>
              </div> -->
              <!-- 列表搜索 -->
              <div id="createSearchBox">
                <el-form
                  label-width="80px"
                  ref="searchCreateForm"
                  :model="searchCreateForm"
                >
                  <el-form-item label="资源名称">
                    <el-input
                      v-model="searchCreateForm.title"
                      placeholder="请输入资源名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label-width="0px">
                    <el-button
                      type="primary"
                      size="mini"
                      icon="el-icon-search"
                      @click="
                        currentPage = 1;
                        onCreateSearch();
                      "
                      >查询</el-button
                    >
                  </el-form-item>
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-folder"
                    class="setCreateSave"
                    @click="setEditSave()"
                    >保存添加</el-button
                  >
                </el-form>
              </div>
              <el-table
                :data="creatSetData"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isOriginal"
                  show-overflow-tooltip
                  label="是否存在原图"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isOriginal == 10"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isOriginal == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSize"
                  show-overflow-tooltip
                  label="文件大小"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage1"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize1"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize1"
                >
                </el-pagination>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="onEdit('editSetForm')"
                >确 定</el-button
              >
              <el-button @click="editDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 删除多媒体集 -->
          <el-dialog
            title="删除多媒体集"
            :visible.sync="deleteDialog"
            width="30%"
            center
          >
            <div>确定删除多媒体集？</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="onDelete">确 定</el-button>
              <el-button @click="deleteDialog = false">取 消</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      tableLoading: false,
      listData: [],
      getAuthority: {},
      versionListData: [],

      currentPage: 1,
      pageSize: 10,
      totalSize: 0,

      currentPage1: 1,
      pageSize1: 10,
      totalSize1: 0,

      currentPage2: 1,
      pageSize2: 10,
      totalSize2: 0,

      dataText: "",
      optionData: [],

      currentType: "",
      selectedValue: "",
      creatSetData: [],
      deleteId: [],
      currentSetData: [],
      createSetType: "", //创建集合选择类型
      editSetType: "",
      addSetForm: {},
      editSetForm: {
        title: "",
        type: "",
      },
      editSetData: [],
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
      logoImgUrl: "",
      logoUpLoadData: {
        type: 1,
      },

      treeData: [],
      treeNode_had: [],
      treeResolve_had: [],
      multipleSelectionTable: [],
      multipleSelectionTable2: [],
      dataList: [],
      sourceList: [],
      searchFileForm: {},
      searchCreateForm: {},
      addSourceForm: {},

      sortContentForm: {},
      treeSearchContent: "",
      listInnerCode: "",
      opentree: true,
      fileName: "",
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      // 弹窗组
      outDialog: false,
      createDialog: false,
      deleteDialog: false,
      listOutDialog: false,
      specialOutDialog: false,
      compareDialog: false,
      logViewDialog: false,
      versionDialog: false,
      editDialog: false,
      // 规则
      addSetRules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        subjectId: [{ required: true, trigger: "blur" }],
      },
      editSetRules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        subjectId: [{ required: true, trigger: "blur" }],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
    this.getSourceList();
  },
  watch: {
    treeSearchContent(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    onCreateSearch() {
      this.updataAddSetType();
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = Object.assign(this.searchFileForm, {});
      params.innerCode = this.listInnerCode;
      params.size = this.pageSize;
      params.page = this.currentPage;
      that.tableLoading = true;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/resource/resourceSetInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.tableLoading = false;
            that.totalSize = response.obj.total;
            that.bkTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/subject/resourceSubject?size=1000&page=1&flag=20",
        type: "GET",
        // data: { type: 10 },
        headers: {
          AuthorizationToken: cookies.get("token"),
        },
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          console.log(data);
          if (node.level == 0) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 点击树
    listClick(node) {
      let that = this;
      that.getAuthority = node;
      if (node.id == -1) {
        that.sortContentForm = {
          id: "-1",
          name: "百科数据资源库",
        };
      } else {
        that.listInnerCode = node.innerCode;
        that.searchParam();
      }
    },
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      this.addSetForm = {};
    },
    // 编辑
    editSet(row) {
      let that = this;
      that.logoImgUrl = row.poster;
      that.editSetType = row.type.toString();
      that.selectedValue = row.subjectInfo.name;
      that.editTypeChange();
      this.editSetForm = {
        id: row.id,
        title: row.title,
        description: row.description,
        poster: row.poster,
        type: row.type,
        subjectId: row.subjectId,
        metaIds: row.metaIds,
      };
      var editIds = this.editSetForm.metaIds.split("##");
      for (var i = 0; i < editIds.length; i++) {
        $.ajax({
          type: "GET",
          dataType: "json",
          data: { id: editIds[i] },
          url: "/zyk/resource/preview",
          success: function (response) {
            if (response.code == 200) {
              that.editSetData.push(response.obj);
            } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            }
          },
          error: function (data) {
            console.log(data);
          },
        });
      }
      console.log(that.editSetData);
      this.editDialog = true;
    },

    // 编辑、删除前确认
    preCheck(current) {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的组织机构",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toEdit") {
        // 编辑确认
        if (this.multipleSelectionTable.length == 1) {
          this.editSource(this.multipleSelectionTable);
        } else {
          this.$message({
            message: "请勿选择多个进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDelete") {
        this.deleteDialog = true;
      }
    },
    // 删除
    onDelete() {
      let that = this;
      that.deleteId = this.multipleSelectionTable.map((item) => {
        return item.id;
      });

      $.ajax({
        url: "/zyk/c/resource/resourceSetInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: that.deleteId.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.deleteDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 恢复确认
    onRevert() {
      let that = this;
      $.ajax({
        type: "POST",
        dataType: "json",
        data: {
          ids: this.deleteId.toString(),
        },
        url: "/zyk/c/resource/resourceSetInfo/revert",
        success: function (response) {
          if (response.code == 200) {
            that.searchParam();
            that.$message({
              message: "恢复成功",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },

    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 选择表格某一行
    handleTableSelectionChange2(val) {
      this.multipleSelectionTable2 = val;
    },
    // 左侧树搜索
    treeSearch(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 分页
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.updataAddSetType();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.updataAddSetType();
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    handleCheckChange() {
      let that = this;
      let res = this.$refs.subjectTree.getCurrentNode();
      that.selectedValue = res.name;
      that.addSetForm.subjectId = res.id;
    },
    // 添加资源集
    addTypeChange() {
      let that = this;
      that.addSetForm = {};
      that.currentSetData = [];
      that.addSetForm.type = this.createSetType;
      switch (this.createSetType) {
        case "1":
          that.currentType = "000005";
          this.updataAddSetType();
          break;
        case "2":
          that.currentType = "000007";
          this.updataAddSetType();
          break;
        case "3":
          that.currentType = "000006";
          this.updataAddSetType();
          break;
      }
    },
    // 修改资源集
    editTypeChange() {
      let that = this;
      that.editSetForm.type = this.editSetType;
      that.editSetData = [];
      switch (this.editSetType) {
        case "1":
          that.currentType = "000005";
          this.updataAddSetType();
          break;
        case "2":
          that.currentType = "000007";
          this.updataAddSetType();
          break;
        case "3":
          that.currentType = "000006";
          this.updataAddSetType();
          break;
      }
    },
    // 加载创建多媒体集的选择列表
    updataAddSetType() {
      let that = this;
      let params = Object.assign({}, this.searchCreateForm);
      params.innerCode = this.currentType;
      params.size = this.pageSize1;
      params.page = this.currentPage1;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/resource/resourceInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.creatSetData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize1 = response.obj.total;
            that.bkTableData1 = response.obj.list;
            that.currentPage1 = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 确认修改
    onEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          if (this.editSetData.length == 0) {
            this.$message({
              message: "请选择要添加的资源",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            let ids = this.editSetData.map((item) => {
                return item.id;
              }),
              urls = this.editSetData.map((item) => {
                return item.httpPath;
              }),
              posters = this.editSetData.map((item) => {
                return item.logoPath;
              }),
              titles = this.editSetData.map((item) => {
                return item.title;
              });
            that.editSetForm.metaIds = ids.join("##");
            that.editSetForm.metaUrls = urls.join("##");
            that.editSetForm.metaPosters = posters.join("##");
            that.editSetForm.metaTitles = titles.join("##");
          }
          that.editSetForm.length = this.editSetData.length;
          console.log(that.editSetForm);
          $.ajax({
            url: "/zyk/c/resource/resourceSetInfo/update",
            type: "POST",
            dataType: "json",
            data: that.editSetForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "修改成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取已添加资源列表
    setCreateSave() {
      let that = this;
      for (var i = 0; i < this.multipleSelectionTable.length; i++) {
        if (
          that.currentSetData.find(
            (item) => item.id == this.multipleSelectionTable[i].id
          )
        ) {
          this.$message({
            message: "请勿重复添加资源",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          that.currentSetData.push(this.multipleSelectionTable[i]);
        }
      }
      that.totalSize2 = that.currentSetData.length;
    },
    // 获取已添加资源列表
    setEditSave() {
      let that = this;
      for (var i = 0; i < this.multipleSelectionTable.length; i++) {
        if (
          that.editSetData.find(
            (item) => item.id == this.multipleSelectionTable[i].id
          )
        ) {
          this.$message({
            message: "请勿重复添加资源",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          that.editSetData.push(this.multipleSelectionTable[i]);
        }
      }
      that.totalSize2 = that.editSetData.length;
    },
    // 确认新增
    onCreate(formName) {
      let that = this;
      console.log(that.addSetForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.currentSetData.length == 0) {
            this.$message({
              message: "请选择要添加的资源",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            let ids = this.currentSetData.map((item) => {
                return item.id;
              }),
              urls = this.currentSetData.map((item) => {
                return item.httpPath;
              }),
              posters = this.currentSetData.map((item) => {
                return item.logoPath;
              }),
              titles = this.currentSetData.map((item) => {
                return item.title;
              });
            that.addSetForm.metaIds = ids.join("##");
            that.addSetForm.metaUrls = urls.join("##");
            that.addSetForm.metaPosters = posters.join("##");
            that.addSetForm.metaTitles = titles.join("##");
          }
          that.addSetForm.length = this.creatSetData.length;
          console.log(that.addSetForm);

          $.ajax({
            url: "/zyk/c/resource/resourceSetInfo/add",
            type: "POST",
            dataType: "json",
            data: that.addSetForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    moveCreate(row, index, type) {
      if (type == "up") {
        if (index == 0) {
          this.$message({
            message: "当前已是首位不可以向上移动",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.swapItems(index, index - 1);
        }
      } else if (type == "down") {
        this.swapItems(index, index + 1);
      }
    },
    moveEdit(row, index, type) {
      if (type == "up") {
        if (index == 0) {
          this.$message({
            message: "当前已是首位不可以向上移动",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.swapItems2(index, index - 1);
        }
      } else if (type == "down") {
        this.swapItems2(index, index + 1);
      }
    },
    swapItems(indexA, indexB) {
      var newdata = this.currentSetData;
      const temp = newdata[indexA];
      this.$set(this.currentSetData, indexA, this.currentSetData[indexB]);
      this.$set(this.currentSetData, indexB, temp);
    },
    swapItems2(indexA, indexB) {
      var newdata = this.editSetData;
      const temp = newdata[indexA];
      this.$set(this.editSetData, indexA, this.editSetData[indexB]);
      this.$set(this.editSetData, indexB, temp);
    },
    toPoster() {
      let that = this;
      if (this.multipleSelectionTable2.length > 1) {
        this.$message({
          message: "封面图只能设置一个资源",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (this.multipleSelectionTable2.length < 1) {
        this.$message({
          message: "请选择一个资源设置为封面",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else {
        that.addSetForm.resourceId = this.multipleSelectionTable2[0].id;
        that.addSetForm.poster = this.multipleSelectionTable2[0].logoPath;
        that.addSetForm.url = this.multipleSelectionTable2[0].httpPath;
        this.$message({
          message: "封面设置成功",
          duration: 0,
          showClose: true,
          type: "success",
          offset: 100,
        });
      }
    },
    toPoster2() {
      let that = this;
      if (this.multipleSelectionTable2.length > 1) {
        this.$message({
          message: "封面图只能设置一个资源",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (this.multipleSelectionTable2.length < 1) {
        this.$message({
          message: "请选择一个资源设置为封面",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else {
        that.editSetForm.resourceId = this.multipleSelectionTable2[0].id;
        that.editSetForm.poster = this.multipleSelectionTable2[0].logoPath;
        that.editSetForm.url = this.multipleSelectionTable2[0].httpPath;
        this.$message({
          message: "封面设置成功",
          duration: 0,
          showClose: true,
          type: "success",
          offset: 100,
        });
      }
    },
    deleteCreate(row) {
      let that = this;
      that.currentSetData = this.currentSetData.filter((item) => item != row);
    },
    deleteEdit(row) {
      let that = this;
      that.editSetData = this.editSetData.filter((item) => item != row);
    },
    // 预览页面跳转
    preview(row) {
      var downloadA = document.createElement("a");
      downloadA.href = "/previewSet?id=" + row.id;
      downloadA.target = "_blank";
      downloadA.click();
    },
     // 发布预览跳转
     publishPreview(row) {
      var downloadA = document.createElement("a");
      downloadA.href = "/setDetail?id=" + row.id;
      downloadA.target = "_blank";
      downloadA.click();
    },
    // 创建索引
    createIndex() {
      let params = Object.assign({}, this.searchFileForm);
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      if (ids.length == 0) {
        params.innerCode = this.listInnerCode;
      } else {
        params.ids = ids.toString();
      }
      $.ajax({
        type: "POST",
        dataType: "json",
        data: params,
        url: "/zyk/resource/createSetIndex",
        success: function (response) {
          if (response.code == 200) {
            that.$message({
              message: "索引已创建",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });

      console.log(params);
    },
  },
};
</script>

<style>
#sortContent {
  clear: both;
  margin-top: -8px;
  margin-left: 170px;
}

.rightBox {
  float: right;
  width: calc(100% - 250px);
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.reorderPreDialog {
  text-align: center;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}

.editFile .el-form-item {
  float: left;
  width: 50% !important;
}
.editFile .editContent {
  width: 100% !important;
}

.editFile .el-form {
  padding: 0 !important;
  height: 500px;
}

.mainBox {
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
}
.mainBox::after,
.mainBox .leftBoxDialog {
  content: "";
  display: inline-block;
  clear: both;
}
.mainBox .leftBoxDialog {
  width: 30%;
  float: left;
  border-right: 1px solid #dcdfe6;
}
.mainBox .leftBoxDialog input {
  width: 100%;
  height: 30px;
  font-size: 14px;
}
.mainBox .leftBoxDialog .el-input,
.mainBox .leftBoxDialog .el-select {
  float: left;
}
.mainBox .leftBoxDialog .leftUp {
  border-bottom: 1px solid #50b58d;
  padding: 10px 0 10px 10px;
}

.mainBox .leftBoxDialog .el-input__icon {
  line-height: 30px;
}
.mainBox .rightBoxDialog {
  width: 69%;
  float: left;
}

.mainBox .rightBoxDialog .dialogBtnBox {
  border-bottom: 1px solid #50b58d;
  padding: 8px 0 8px 10px;
}

.mainBox .rightBoxDialog .el-form {
  padding: 10px 20px;
}

.mainBox .rightBoxDialog .el-form .el-textarea textarea {
  height: 300px;
}

#searchBox {
  padding-bottom: 22px;
}

#searchBox .el-select {
  width: 202px;
}

#searchBox .el-form-item {
  margin-bottom: 0;
}

#searchBox .el-form button.el-button {
  margin-left: 20px !important;
}

#searchBox .el-date-editor .el-range__icon {
  line-height: 25px;
}

#searchBox.el-date-editor .el-range-separator {
  line-height: 23px;
}

#createSearchBox {
  padding-bottom: 22px;
}

#createSearchBox .el-select {
  width: 202px;
}

#createSearchBox .el-form {
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

#createSearchBox .el-form-item {
  margin-bottom: 0;
  float: left;
  width: 300px;
}

#createSearchBox .el-form button.el-button {
  margin-left: 20px !important;
}

#createSearchBox .el-date-editor .el-range__icon {
  line-height: 25px;
}

#createSearchBox.el-date-editor .el-range-separator {
  line-height: 23px;
}

#creatCheckTableBox {
  box-shadow: 0 0 2px #888;
}

#creatTableBox {
  box-shadow: 0 0 2px #888;
  margin-bottom: 20px;
}

.createSetType {
  margin-bottom: 20px;
}

.setCreateSave {
  position: absolute;
  right: 1%;
  top: 28%;
}
</style>